<template>
    <div class="md:w-1/2 p-4 w-full xl:w-1/4">
        <div @click="openSection" class="bg-white border cursor-pointer hover:border-blue-500 p-4 rounded shadow" :class="[ section.open ? 'border-blue-600' : 'border-transparent' ]" :id="`${section.slug}-faq-section-link`">
            <div class="flex flex-col items-center py-1">
                <div class="mb-5">
                    <slot>
                        <svg class="h-8 w-8" :class="[ section.open ? 'text-blue-600' : 'text-gray-500' ]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line></svg>
                    </slot>
                </div>
                <h5 class="font-medium my-0 text-base" :class="[ section.open ? 'text-blue-600' : 'text-gray-500' ]">{{ section.name }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            required: true,
        },
        section: {
            type: Object,
            required: true,
        },
    },

    methods: {
        openSection() {
            Bus.$emit('openFaqSection', { index: this.index });
        },
    },
};
</script>
